import type { Category } from "@/types/comic";

export const categories: Category[] = [
  {
    slug: "romance",
    name: "爱情",
    desc: "心动、守护与命运交织的浪漫故事，甜宠虐恋一网打尽。",
    icon: "ri-heart-3-line",
    count: 326,
  },
  {
    slug: "fantasy",
    name: "奇幻",
    desc: "魔法、异世界与冒险的奇幻旅程，想象力没有边界。",
    icon: "ri-magic-line",
    count: 218,
  },
  {
    slug: "action",
    name: "动作",
    desc: "热血战斗与快节奏对决，肾上腺素持续飙升。",
    icon: "ri-sword-line",
    count: 194,
  },
  {
    slug: "school",
    name: "校园",
    desc: "青春、友谊与初恋的校园日常，重返最闪亮的年纪。",
    icon: "ri-book-2-line",
    count: 152,
  },
  {
    slug: "city",
    name: "都市",
    desc: "职场、财阀与都市人的情感与成长，贴近现实又上头。",
    icon: "ri-building-2-line",
    count: 176,
  },
  {
    slug: "mystery",
    name: "悬疑",
    desc: "谜案、推理与反转不断，越看越停不下来的烧脑体验。",
    icon: "ri-find-replace-line",
    count: 98,
  },
  {
    slug: "scifi",
    name: "科幻",
    desc: "机甲、末世与未来科技，探索人类想象的尽头。",
    icon: "ri-rocket-2-line",
    count: 87,
  },
];

export const categoryMap: Record<string, Category> = {
  romance: categories[0],
  fantasy: categories[1],
  action: categories[2],
  school: categories[3],
  city: categories[4],
  mystery: categories[5],
  scifi: categories[6],
};

export const navCategories = [
  { slug: "romance", name: "爱情" },
  { slug: "fantasy", name: "奇幻" },
  { slug: "action", name: "动作" },
  { slug: "hot", name: "热门" },
  { slug: "finished", name: "完结" },
];